import JSConfetti from 'js-confetti';
import { useRef, useEffect } from 'react';
import styled from 'styled-components';
// import { confetti } from 'utils/confetti';

const logoSvg = (
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  color: string
): string => `<svg width="90" fill="#ffffff" height="90" xmlns="http://www.w3.org/2000/svg" class="logo-shape" data-name="logo-shape" viewBox="1.17 0 107.09 98.84">
 <path class="cls-1" d="M54.72,49.42v49.42H1.17c0-27.3,22.13-49.42,49.42-49.42h4.12Z"></path>
 <path class="cls-1" d="M54.72,49.42V0h53.54c0,27.3-22.13,49.42-49.42,49.42h-4.12Z"></path>
 </svg>`;

type ConfettiProps = {
  onComplete: () => void;
};

export const Confetti: React.FC<ConfettiProps> = ({ onComplete }) => {
  const canvasRef = useRef(null);

  const goConfetti = async (): Promise<void> => {
    if (canvasRef.current) {
      const jsConfetti = new JSConfetti({ canvas: canvasRef.current as HTMLCanvasElement });

      await jsConfetti.addConfetti({
        confettiColors: ['#052975', '#8ff8ff'],
        confettiRadius: 10,
        // confettiNumber: 1000,
        emojis: ['🌈', '⚡️', '💥', '✨', '💫', '🦄'],
        emojiSize: 80,
        confettiNumber: 150,
        svgs: [logoSvg('#052975'), logoSvg('#8ff8ff')],
        svgSize: 90,
      });
      onComplete();
    }
  };

  useEffect(() => {
    goConfetti();
  }, []); // eslint-disable-line

  return (
    <StyledConfetti aria-hidden="true">
      <canvas ref={canvasRef} />
      {/* <button onClick={goConfetti}>Go again</button> */}
    </StyledConfetti>
  );
};

export const StyledConfetti = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  > canvas {
    width: 100%;
    height: 100%;
  }

  > button {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export default Confetti;
